import { useContext } from 'react'
import context from './context'

const useHeader = () => useContext(context)

export default useHeader
